'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import classnames from 'classnames';

import Button from 'react-bootstrap/Button';

import { VscMortarBoard } from "react-icons/vsc";
import { BsInbox } from "react-icons/bs";
import { IoSearchOutline } from "react-icons/io5";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import SimpleState from '@uw-it-sis/lib-react/lib/SimpleState';
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import {withRouter} from "@uw-it-sis/lib-react/lib/WithRouter";

import AppNavigationLink from './AppNavigationLink';
import appNavigationStore from "./AppNavigationStore";

class AppNavigation extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = appNavigationStore;

        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.buildDoneComponent = this.buildDoneComponent.bind(this);
        this.buildPendingComponent =this.buildPendingComponent.bind(this);
    }

    handleLoginClick = () => appStore.doLogin();

    componentDidMount() {
        this.store.mount(this.props.location);
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    componentDidUpdate() {
        let currentLocation = this.store.buildCompareLocation();

        if (currentLocation !== this.store.navigationCompareLocation) {
            this.store.resetNavigationCompareLocation();
        }

        const appNavigation = document.getElementById("app-navigation");

        /**
         * FIXME: Fix for Edge browser, CSS hover and focusin not triggering, so using JS fix for now
         */
        if ( this.store.state === States.done && /Edge/.test(navigator.userAgent) ) {
            appNavigation.addEventListener("mouseover focusin", function() {
                document.body.classList.add("nav-expanded");
            });

            appNavigation.addEventListener("mouseout focusout", function() {
                document.body.classList.remove("nav-expanded");
            });
        }

        if ( this.store.state === States.done ) {
            appNavigation.addEventListener("keydown", function (e) {
                let isEscape = false;
                if ("key" in e) {
                    isEscape = (e.key === "Escape" || e.key === "Esc");
                }
                if (isEscape) {
                    const h = `#main-content`;
                    const e = document.querySelector(h);
                    const p = e.parentElement;
                    if (p) {
                        const a = document.createElement('span');
                        a.setAttribute('id', `${h}-insert-point`);
                        a.setAttribute('tabIndex', '0');
                        p.insertBefore(a, e);
                        a.focus();
                        a.addEventListener('blur', () => {
                            p.removeChild(a);
                        })
                    }
                }
            });
        }
    }

    buildDoneComponent() {
        const currentPlanableTerm = this.store.getCurrentPlanableTerm();
        const compareLocation = this.store.navigationCompareLocation;
        let comparePathname = this.store.navigationComparePathname;

        const navigationLinkHrefs = [
            "/course/",
            "/program/",
            "/course/#/bookmarks",
            "/program/#/bookmarks",
            "/plan/#/",
            "/plan/#/schedule",
            "/audit/#/degree",
            "/audit/#/plan",
            "/audit/#/equivalency"
        ];

        // if the compare location matches one of the navigation links, we want to match the most specific thing first for highlighting
        // i.e. matching compareLocation of "/program/#/bookmarks" in preference of using comparePathname to match, i.e. "/program/"
        // This only applies to the hrefs for react apps, since the KRAD global nav handles its own highlighting
        if (navigationLinkHrefs.includes(compareLocation)) {
            // to make sure the location ( more specific ) is highlighted, and not the match for the pathname, empty out the pathname
            comparePathname = "";
        }

        let sqvUrl, sbUrl, planImpex;

        if (currentPlanableTerm) {
            sqvUrl =
                <li>
                    <AppNavigationLink compareLocation={compareLocation} href={"/plan/#/" + currentPlanableTerm.shortName.toLowerCase().replace(/\s+/g, '')}>
                        My {currentPlanableTerm.codeName} {currentPlanableTerm.year}
                    </AppNavigationLink>
                </li>;
            sbUrl =
                <li>
                    <AppNavigationLink compareLocation={compareLocation} href="/plan/#/schedule">
                        Schedule Builder
                    </AppNavigationLink>
                </li>;
        }

        // Create a login link.
        let signIn = null;
        if (! appStore.isAuthenticated()) {
            signIn =
                <li className="app-navigation-signin">
                    <Button id="sign-in-nav"
                            variant="inline-link"
                            onClick={this.handleLoginClick}>
                        Sign in
                    </Button>&nbsp;to use more features
                </li>;
        }

        let hasAdviserRole = appStore.hasRoles("ADVISER");
        // Only give Plan Impex global nav to advisers at this point.
        if ( hasAdviserRole ) {
            planImpex =
                <li>
                    <AppNavigationLink compareLocation={compareLocation} href="/impex">Adviser Sample Plans (Beta)</AppNavigationLink>
                </li>
        }

        return (
            <nav id="app-navigation" className="app-navigation d-flex overflow-hidden d-print-none" role="navigation" aria-label="MyPlan">
                <ul className="list-unstyled">
                    {signIn}
                    <li className={appStore.getApplicationName() === 'course' || appStore.getApplicationName() === 'program' ? 'active':''}>
                        <div className="app-navigation-header app-navigation-header--courses d-flex align-items-center">
                            <IoSearchOutline aria-hidden={true} size="2rem" className="mx-3" />
                            <span>Explore</span>
                        </div>
                        <ul className="list-unstyled app-navigation-list--4">
                            <li><AppNavigationLink compareLocation={comparePathname} href="/course/" unauthenticated>Find Courses</AppNavigationLink></li>
                            <li><AppNavigationLink compareLocation={comparePathname} href="/program/" unauthenticated>Find Programs</AppNavigationLink></li>
                            <li><AppNavigationLink compareLocation={compareLocation} href="/course/#/bookmarks">View Course Bookmarks</AppNavigationLink></li>
                            <li><AppNavigationLink compareLocation={compareLocation} href="/program/#/bookmarks">View Program Bookmarks</AppNavigationLink></li>
                        </ul>
                    </li>
                    <li className={appStore.getApplicationName() === 'plan' || appStore.getApplicationName() === 'impex' ? 'active':''}>
                        <div className="app-navigation-header app-navigation-header--plan d-flex align-items-center">
                            <BsInbox aria-hidden={true} size="2rem" className="mx-3" />
                            <span>Manage</span>
                        </div>
                        <ul className={"list-unstyled app-navigation-list--" + (hasAdviserRole ? '4':'3')}>
                            {sqvUrl}
                            {sbUrl}
                            <li><AppNavigationLink compareLocation={compareLocation} href="/plan/#/">My Academic Year</AppNavigationLink></li>
                            {planImpex}
                        </ul>
                    </li>
                    <li className={classnames({'active': appStore.getApplicationName() === 'audit'})}>
                        <div className="app-navigation-header app-navigation-header--track d-flex align-items-center">
                            <VscMortarBoard aria-hidden={true} size="2rem" className="mx-3" />
                            <span>Track</span>
                        </div>
                        <ul className={classnames('list-unstyled', 'app-navigation-list--multiline', 'app-navigation-list--' + (appStore.isStudent() || appStore.isAdviser() ? '3':'2'))}>
                            {appStore.isStudent() || appStore.isAdviser() ? <li><AppNavigationLink compareLocation={compareLocation} href="/audit/#/degree">Audit Degree (DARS)</AppNavigationLink></li>:''}
                            <li><AppNavigationLink compareLocation={compareLocation} href="/audit/#/plan">Audit Plan</AppNavigationLink></li>
                            <li><AppNavigationLink compareLocation={compareLocation} href="/audit/#/equivalency">Find CTC Transfer Equivalency</AppNavigationLink></li>
                        </ul>
                    </li>
                </ul>
            </nav>
        );
    }

    buildPendingComponent() {
        return (
            <span className="sr-only">Loading Navigation</span>
        );
    }

    render() {
        return <SimpleState state={this.store.state} doneComponentBuilder={this.buildDoneComponent} pendingComponentBuilder={this.buildPendingComponent} name="AppNavigation"/>;
    }
}

export default withRouter(observer(AppNavigation));